import React from 'react';
import { ApolloProvider } from '@apollo/client/react';
import { FormProvider } from './FormContext';
import { PaymentProvider } from './PaymentContext';
import { StepperProvider } from './StepperContext';
import { ProductProvider } from './ProductContext';
import { apolloClient } from '../../../services/membershipApi/apollo/client';

interface SignupProvidersProps {
    children: React.ReactNode;
}

/**
 * Combined provider that wraps all signup-related contexts
 * This ensures all contexts are available throughout the signup flow
 */
export const SignupProviders: React.FC<SignupProvidersProps> = ({ children }) => {
    return (
        <ApolloProvider client={apolloClient}>
            <FormProvider>
                <PaymentProvider>
                    <ProductProvider>
                        <StepperProvider totalSteps={4}>
                            {children}
                        </StepperProvider>
                    </ProductProvider>
                </PaymentProvider>
            </FormProvider>
        </ApolloProvider>
    );
};
